import {Injectable} from '@angular/core';
import {BankIdClientV6} from 'app/bankid';
import {GlobalService} from 'app/global/global.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {RoleDetail} from '../signing-page/signing-page.dto';
import {SigningServiceHttp} from '../signing-service';

@Injectable({
    providedIn: 'root'
})
export class DocumentKeyService {

    constructor(
        private http: SigningServiceHttp,
        private BankIdClientV6: BankIdClientV6,
        private globalService: GlobalService,
        private deviceService: DeviceDetectorService
    ) {
    }
    /**
    * get the order ref on authenticate bankid
    * @returns response
    */
    async authenticateBankid(roleDetail:RoleDetail) {
        this.BankIdClientV6.options = { ...this.BankIdClientV6.options, roleId: Number(roleDetail.id), production: false, refreshInterval: 1000, v: 'v6.0' };
        const requirement = roleDetail.recipient.persnol_no ? { requirement: { personalNumber: String(roleDetail.recipient.persnol_no).replace(/-/g, "") } } : null;
        const response = await this.BankIdClientV6.authenticate({
        endUserIp: "127.0.0.1",
        ...requirement
        });
        return response;
    }

    async authenticateAndCollect(orderRef: string, autoStartToken: string, os: string): Promise<boolean> {
        await this.globalService.openBankIdApp(autoStartToken, this.deviceService.isMobile(), os);

        return new Promise<boolean>((resolve, reject) => {
            const timer = setInterval(() => {
                this.BankIdClientV6.collect({ orderRef: orderRef })
                    .then(res => {
                        if (res.status === 'complete') {
                            clearInterval(timer);
                            resolve(true);
                        } else if (res.status === 'failed') {
                            clearInterval(timer);
                            reject(new Error(res.hintCode));
                        }
                    })
                    .catch(err => {
                        clearInterval(timer);
                        reject(err);
                    });
            }, 1000);
        });
    }

    /**
     * authenticate password
     * @param role_id
     * @param document_id
     * @param data
     * @returns Promiss
     */
    viewDocument(role_id: number, document_id: number, data: { pin_code?:string, password?: string}) {
        return this.http.post(`sign-document/${role_id}/${document_id}/document-access`, data);
    }

    /**
     * send sms to the recipient phone no
     * @param role_id 
     * @param phone_no 
     * @returns response
     */
    sendPinCode(role_id: number, phone_no:string){
        return this.http.post(`sign-document/${role_id}/send-pincode`, {phone_no});
    }
}
